import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Branch_Location_Pincode_URL, Lead_Service_URL } from "../Url";

export function getPincodeOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url:
        `${Branch_Location_Pincode_URL}/search/Pincode?pincode=` + inputValue,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        if (
          err?.response?.status === "403" &&
          err?.response?.data?.error?.logoutStatus
        ) {
          dispatch(clearLogoutData());
        } else {
          if (err.response) {
            return err.response;
          }
        }
      });
}

export function getSalesManagerOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/search/AllCurrentSmUsername`,
      params: {
        userFullName: inputValue,
        // portal: "SALES_PORTAL",
        // roleType: "SM",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        if (
          err?.response?.status === "403" &&
          err?.response?.data?.error?.logoutStatus
        ) {
          dispatch(clearLogoutData());
        } else {
          if (err.response) {
            return err.response;
          }
        }
      });
}

export function getSalesExecutiveOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/search/AllCurrentSeUsername`,
      params: {
        userFullName: inputValue,
        // portal: "SALES_PORTAL",
        // roleType: "SE",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        if (
          err?.response?.status === "403" &&
          err?.response?.data?.error?.logoutStatus
        ) {
          dispatch(clearLogoutData());
        } else {
          if (err.response) {
            return err.response;
          }
        }
      });
}

export function getServicingBranchOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url:
        `${Lead_Service_URL}/search/assignedAvanseBranch?avanseBranch=` +
        inputValue,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        if (
          err?.response?.status === "403" &&
          err?.response?.data?.error?.logoutStatus
        ) {
          dispatch(clearLogoutData());
        } else {
          if (err.response) {
            return err.response;
          }
        }
      });
}
